import constants from '@/utils/constants';

export const PLAYSTORE_LINK = 'https://phon.pe/ppb';
export const APPSTORE_LINK = 'https://phon.pe/ppb';

export const MERCHANT_HELPDESK_EMAIL = 'merchant-desk@phonepe.com';
export const TERMS_AND_CONDITIONS_LINK =
	'https://terms-and-conditions.phonepe.com/general/merchant-terms-and-conditions';
export const loginCarouselData = [
	{
		key: 'slide-1',
		title: 'Manage your Business Efficiently',
		subTitle:
			'Check daily payments, manage settlements, track transactions & much more!',
	},
];
const copyRightYear = new Date().getFullYear();

//NOTE: Need to migrate this to Chimera
export const ADMIN_ROLE_ID =
	constants.BUILD_ENVIRONMENT === 'production'
		? 'R1908081841518350641692'
		: 'R1812071121230086870849';

export const PV_SDK_BASE_URL = `${process.env.REACT_APP_KYC_SDK_BASE_URL}/`;
export const HELP_VIDEO_LINK = `https://www.youtube.com/embed/KqlqDHqTH6Q?autoplay=1&mute=0&fs=0&rel=0`;

export const TNC_TEXT = 'Terms and Conditions';
export const RIGHTS_RESERVED_TEXT = '©2023 All rights reserved';
export const POWERED_BY_PHONEPE_TEXT = 'Powered by PhonePe';
export const TNC_LINK_P2ML =
	'https://terms-and-conditions.phonepe.com/general/merchant-terms-and-conditions-p2ml';
export const TNC_LINK_ONLINE =
	'https://terms-and-conditions.phonepe.com/general/merchant-terms-and-conditions-online';
export const TNC_LINK_OFFLINE =
	'https://terms-and-conditions.phonepe.com/general/merchant-terms-and-conditions-offline';
export const ALL_RIGHTS_RESERVED = `© ${copyRightYear} PhonePe Ltd. (Formerly known as "PhonePe Private Limited"). All rights reserved.`;
export const PRIVACY_POLICY_TEXT = 'Privacy Policy';
export const MERCHANT_TNC_LINK =
	'https://terms-and-conditions.phonepe.com/general/merchant-terms-and-conditions';
export const PRIVACY_POLICY_LINK = 'https://www.phonepe.com/privacy-policy/';

export const PAGE_NOT_FOUND_TITLE = 'Page Not Found';
export const PAGE_NOT_FOUND_MESSAGE =
	'The page you are looking for doesn’t exists. Please check the URL and try again.';
export const CONTACT_US = 'Contact Us';
export const GREETING_MESSAGE = 'Hello Merchant';
export const IMAGE_STATIC_URL =
	'https://imgstatic.phonepe.com/images/pfb-web/common';
export const PG_REGISTRATION_LINK_UTM_SRC =
	'/register?utm_source=homepage_banner_pg_pfb_website';
export const LOGIN_CAROUSEL_INTERVAL = 10000;
export const APP_LINK_URL = 'https://phonepebusiness.onelink.me/LSFq/ihkidzta';
export const DEV_DOCS_LINK = 'https://developer.phonepe.com';
export const MERCHANT_SUPPORT_TICKET_PORTAL_LINK = `${constants.TICKETS_BASE_URL}/en/support`;

export const SUBSCRIPTION_SETUP_CONTEXT = 'SUBSCRIPTION_SETUP_CONTEXT';
export const SUBSCRIPTION_REDEMPTION_CONTEXT_V1 =
	'SUBSCRIPTION_REDEMPTION_CONTEXT_V1';
export const UTM_KEYS = {
	UTM_SOURCE: 'utm_source',
};

export const BANKS_IMAGES_SUB_URL = '/banks';

export const PG_REGISTER_LINK_UTM =
	'https://www.phonepe.com/business-solutions/payment-gateway/register/?utm_source=unable_to_register';

export const INVALID_CSRF_ERROR_CODE = 'CF004';
export const PG_SIGNUP_PATH =
	'https://business.phonepe.com/register?utm_source=pp_website_organic_redirect';
export const PG_SISA_VERIFICATION_URL =
	'https://seal.controlcase.com/index.php?page=showCert&cId=4184241003';
